import React from 'react';
import './Testimonials.css';

import { Heading } from '../../../components';
import { testiContent } from '../../../constants';

import { FaQuoteRight, FaStar } from 'react-icons/fa';

// Import Swiper core and required modules
import { Pagination, Autoplay } from 'swiper';
 
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles  
import 'swiper/css'; 
import 'swiper/css/pagination';



const Testimonials = () => {
  return (
    <section className='testimonials'>

      {/* Section heading */}
      <Heading title={'Client Testimonials'} subTitle={`what our client's say`} />

      <div className='testimonial-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Pagination, Autoplay]}
          spaceBetween={10}
          loop={true}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            // When window width is >= 768px
            768: {
              slidesPerView: 1,
            }, 
            991: {
              slidesPerView: 2,
            },
          }} >
          {/* Map over the testiContent array to render each testimonial */}
          {testiContent.map((testimonial) => {

            // Destructure testimonial object
            const { id, image, content, name, title } = testimonial;

            return (
              <SwiperSlide className='testi-item' key={id}>
                
                <img src={image} alt={name} /> {/* User Image */}
                <FaQuoteRight className='quote-right' /> {/* Testimonial quote icon */}
                <p>{content}</p> {/* Testimonial */}

                {/* Author Rating */}
                <div className="rating">
                  <FaStar className="icon" />
                  <FaStar className="icon" />
                  <FaStar className="icon" />
                  <FaStar className="icon" />
                  <FaStar className="icon" />
                </div>

                {/* Author Details */}
                <div className='text'>
                  <h4>{name}</h4> {/* Author name */}
                  <h6>{title}</h6> {/* Author title */}
                </div>

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Testimonials;